import { gql } from '@apollo/client';
import Fragments from './fragments';

export const REQUIRED_DOCUMENT_UPDATED = gql`
  subscription Subscription {
    requiredDocumentUpdated {
      requiredDocument {
        ...requiredDocumentItem
      }
    }
  }
  ${Fragments.requiredDocumentItem}
`;
